import React, { type FunctionComponent, type ReactNode } from 'react';
import {
    Drawer,
    DrawerBody,
    DrawerHeader,
    DrawerOverlay,
    DrawerContent,
    DrawerCloseButton,
    DrawerFooter,
} from '@chakra-ui/react';
import { type Size } from '../../interface/Chakra';
import LoadingIndicator from '../LoadingIndicator';
import { type CombinedError } from 'urql';
import ErrorBox from '../ErrorBox';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    title: ReactNode;
    footer?: ReactNode;
    children: ReactNode;
    size?: Size;
    showSpinner?: boolean;
    error?: CombinedError;
    useInert?: boolean;
    closeOnEsc?: boolean;
}

export const DetailsDrawer: FunctionComponent<Props> = (props: Props) => {
    const { size = 'md', showSpinner = false, error, useInert, closeOnEsc } = props;

    return (
        <Drawer
            isOpen={props.isOpen}
            placement="right"
            onClose={props.onClose}
            size={size}
            useInert={useInert}
            closeOnEsc={closeOnEsc}
        >
            <DrawerOverlay />
            <DrawerContent>
                <DrawerCloseButton mt={2} />
                {showSpinner ? (
                    <LoadingIndicator />
                ) : (
                    <>
                        {props.title && <DrawerHeader>{props.title}</DrawerHeader>}
                        <DrawerBody>
                            {error ? <ErrorBox title={error.name} message={error.message} /> : props.children}
                        </DrawerBody>
                        {props.footer && <DrawerFooter>{props.footer}</DrawerFooter>}
                    </>
                )}
            </DrawerContent>
        </Drawer>
    );
};
